import { useScrollReveal } from '../../../hooks/useScrollReveal';

const VALUES = [
  {
    icon: 'ri-shield-check-line',
    title: 'Confidencialidad Total',
    desc: 'Todo lo que se trate en la mediación es estrictamente confidencial, protegiendo los intereses de todas las partes.',
  },
  {
    icon: 'ri-scales-line',
    title: 'Imparcialidad Garantizada',
    desc: 'Nuestros mediadores actúan como facilitadores neutros, sin favorecer a ninguna de las partes en conflicto.',
  },
  {
    icon: 'ri-time-line',
    title: 'Resolución Rápida',
    desc: 'La mediación resuelve conflictos en semanas, frente a los años que pueden durar los procesos judiciales.',
  },
  {
    icon: 'ri-check-double-line',
    title: 'Acuerdos Duraderos',
    desc: 'Los acuerdos alcanzados en mediación son más duraderos porque ambas partes los construyen juntas.',
  },
];

export default function About() {
  const { ref, isVisible } = useScrollReveal<HTMLElement>();

  return (
    <section ref={ref} id="sobre-nosotros" className="py-28 bg-[#F4F7FA]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: Text */}
          <div
            className={`transition-all duration-700 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
            style={{ transitionDelay: isVisible ? '100ms' : '0ms' }}
          >
            <span className="text-[#3D9E8C] text-sm font-semibold tracking-widest uppercase">Sobre Nosotros</span>
            <h2 className="mt-3 text-4xl md:text-5xl font-bold text-[#1B3A5C] leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
              Mediadores certificados<br />a tu servicio
            </h2>
            <p className="mt-5 text-gray-600 leading-relaxed text-[15px]">
              <strong>Mediatio Global</strong> es un despacho de mediadores certificados, abogados y psicólogos con más de 10 años de experiencia ayudando a particulares, familias y empresas a resolver sus conflictos fuera de los juzgados.
            </p>
            <p className="mt-4 text-gray-600 leading-relaxed text-[15px]">
              Estamos inscritos en el <strong>Registro de Mediadores del Ministerio de Justicia</strong> y somos acreditados conforme a la Ley Orgánica 5/2012. Ofrecemos mediación presencial y 100% online, adaptándonos a cada caso.
            </p>

            <div className="mt-8 flex flex-wrap gap-6">
              {[
                { value: '+2.500', label: 'Casos resueltos' },
                { value: '95%', label: 'Tasa de acuerdo' },
                { value: '10+', label: 'Años de experiencia' },
              ].map((s, idx) => (
                <div
                  key={s.label}
                  className={`flex flex-col transition-all duration-700 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
                  style={{ transitionDelay: isVisible ? `${300 + idx * 100}ms` : '0ms' }}
                >
                  <span className="text-3xl font-bold text-[#1B3A5C]" style={{ fontFamily: "'Playfair Display', serif" }}>
                    {s.value}
                  </span>
                  <span className="text-gray-500 text-sm">{s.label}</span>
                </div>
              ))}
            </div>

            <button
              onClick={() => {
                const el = document.getElementById('contacto');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="mt-10 inline-flex items-center gap-2 px-7 py-3.5 bg-[#1B3A5C] text-white text-sm font-semibold rounded-full hover:bg-[#14304f] transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              Conocer al Equipo
              <i className="ri-arrow-right-line" />
            </button>
          </div>

          {/* Right: Image + values */}
          <div
            className={`flex flex-col gap-6 transition-all duration-700 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
            style={{ transitionDelay: isVisible ? '300ms' : '0ms' }}
          >
            <div className="w-full h-64 rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/25654fee008a7f101fd5287d67a16e4e.jpg"
                alt="Equipo de Mediatio Global"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="grid grid-cols-2 gap-4">
              {VALUES.map((v, idx) => (
                <div
                  key={v.title}
                  className={`bg-white rounded-xl p-5 flex flex-col gap-3 transition-all duration-700 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
                  style={{ transitionDelay: isVisible ? `${400 + idx * 100}ms` : '0ms' }}
                >
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-[#E8F4F1]">
                    <i className={`${v.icon} text-[#3D9E8C] text-xl`} />
                  </div>
                  <h4 className="font-semibold text-[#1B3A5C] text-sm">{v.title}</h4>
                  <p className="text-gray-500 text-xs leading-relaxed">{v.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
